<template>

    <v-container class="pt-0 pb-5">
        <v-row>
            <v-col cols="12">
                <div class="pa-2 rounded elevation-1 bg-white">
                    <SportipsButton backButton chevronLeft>Retour</SportipsButton>
                    <div class="text-h5 font-weight-bold my-2">Les performances</div>
                    <!-- Liste des inscriptions -->
                    <InscriptionsList mode="lce_performance" v-if="isBeforeSeptember25"></InscriptionsList>
                    <div v-else>

                        <div class="fmy-2">Les performances seront visibles ultérieurement.</div>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-container>

</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import InscriptionsList from "@/components/ListInscriptions/InscriptionsList.vue";

export default {
    components: { InscriptionsList },
    data() {
        return {};
    },
    computed: {
        ...mapStores(useMainStore),
        isBeforeSeptember25() {
            const now = new Date();
            const septembre25 = new Date('2026-09-24');
            return now < septembre25;
        },

    },
    methods: {},

    mounted() {
        const is_lce26 = this.mainStore.module?.base == 'LCE26';
        if (!is_lce26) {
            this.$router.push({ name: "Home" });
        }

    },
};
</script>

<style lang="scss" scoped></style>